import { useLayoutEffect, useRef } from 'react';

// Fit the actual rendered font, not a viewport estimate. One size per row/rail
// keeps labels consistent; fixed button dimensions keep the game geometry stable.
export const useFittedPlinkoLabels = (contentKey, selector) => {
  const ref = useRef(null);
  useLayoutEffect(() => {
    const element = ref.current;
    if (!element) return;
    const mobile = window.matchMedia('(max-width: 1023px)');
    let active = true;
    const fit = () => {
      if (!active) return;
      element.style.removeProperty('--plinko-label-size');
      if (!mobile.matches) return;
      const labels = [...element.querySelectorAll(selector)];
      if (!labels.length) return;
      const widths = labels.map((label) => {
        const button = label.closest('button'), style = getComputedStyle(button);
        return button.getBoundingClientRect().width - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight)
          - parseFloat(style.borderLeftWidth) - parseFloat(style.borderRightWidth) - 1;
      });
      if (widths.some((width) => width <= 0)) return;
      const maximum = parseFloat(getComputedStyle(element).getPropertyValue('--plinko-label-max-size'));
      if (!Number.isFinite(maximum)) return;
      const ratio = Math.min(1, ...labels.map((label, index) => widths[index] / label.getBoundingClientRect().width));
      let size = Math.floor(maximum * ratio * 20) / 20;
      element.style.setProperty('--plinko-label-size', `${size}px`);
      // Some fonts use whole-pixel glyph advances at these compact sizes.
      while (size > 1 && labels.some((label, index) => label.getBoundingClientRect().width > widths[index])) {
        size = Math.max(1, size - .25);
        element.style.setProperty('--plinko-label-size', `${size}px`);
      }
    };
    const observer = new ResizeObserver(fit);
    observer.observe(element);
    mobile.addEventListener('change', fit);
    document.fonts.addEventListener('loadingdone', fit);
    document.fonts.ready.then(fit);
    fit();
    return () => {
      active = false;
      observer.disconnect();
      mobile.removeEventListener('change', fit);
      document.fonts.removeEventListener('loadingdone', fit);
      element.style.removeProperty('--plinko-label-size');
    };
  }, [contentKey, selector]);
  return ref;
};